import React from 'react';

const WorkingSectors = () => {
  return (
    <div className="card h-100 border-0 shadow-sm org-card position-relative">
      {/* Top blue gradient line */}
      <div className="card-top-line position-absolute top-0 w-100"></div>
      
      <div className="card-body p-4 p-xl-5 mt-2">
        <h4 className="org-title mb-4 pb-3 border-bottom">Working Sectors</h4>
        
        <div className="row g-4">
          <div className="col-sm-6">
            <p className="org-label">Primary Sectors</p>
            <p className="org-value large mb-0">Education & Literacy</p>
          </div>
          <div className="col-sm-6">
            <p className="org-label">Secondary Sectors</p>
            <p className="org-value large mb-0">Health & Family Welfare</p>
          </div>
          
          <div className="col-12 border-top pt-3 mt-4 opacity-50"></div> {/* Subtle Divider */}
          
          <div className="col-sm-6">
            <p className="org-label">Operational State</p>
            <p className="org-value mb-0">Uttar Pradesh</p>
          </div>
          <div className="col-sm-6">
            <p className="org-label">Operational District</p>
            <p className="org-value mb-0">JAUNPUR</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkingSectors;